import { Component } from '@angular/core';

@Component({
    selector: 'pr-separator',
    template: '',
    styleUrls: ['./pr-separator.component.scss'],
    standalone: false
})
export class PrSeparatorComponent {}
